<template>
    <div>
         <div class="count-ticket-wrapper box-shadow-card" v-if="isShowBookingDetail">
                    <div class="row" >
                      <div class="col-md-6 col-sm-6 text-center border-right-line">
                        <div class="number">{{agentBookingDetail.pendingBookings}}</div>
                        <span >
                          <cHelpTip :content="$t('helpTip.cBkngDtlTcktQue')" class="position-absolute right-10px top--12px"></cHelpTip>
                        </span>
                        <div class="title">{{ $t("cAgentDetail.ticktQue") }}</div>
                      </div>
                      <div class="col-md-6 col-sm-6 text-center ">
                        <div class="number">{{agentBookingDetail.ticketedBookings}}</div>
                        <span >
                          <cHelpTip :content="$t('helpTip.cBkngDtlIssuedBook')" class="position-absolute right-10px top--12px"></cHelpTip>
                        </span>
                        <div class="title">{{ $t("cAgentDetail.booking") }}
                          <!-- <div
                        class="c-red"
                        v-c-tooltip.hover="{ content: $t('cAgentDetail.issuedBookingTooltip') , active:false }"
                      >
                              <div class="search-info-icon">
                                  <img src="@imgPath/img/svg/icons/info-icon.svg" alt="">
                              </div> -->
<!--                        <CIcon color="#cd0606" name="cil-info" size="lg" />-->
                      <!-- </div> -->
                        </div>
                      </div>
                      <!-- <div class="col-md-4 col-sm-6 text-center">
                        <div class="number">{{agentBookingDet.pending}}</div>
                        <div class="title">{{ $t("cAgentDetail.pending") }}</div>
                      </div> -->
                    </div>
                  </div>

    </div>
</template>

<script>
import { COMPONENT_NAME } from "../../util/constants";
import { handleJWT, getErrorAlertValue } from "../../util/util";
import Logger from "../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES
} from "../../config/API_DATA";
import BaseConfiguration from "../../config/base";
import cHelpTip from "../../components/cHelpTip"

export default {
    name: COMPONENT_NAME.C_AGENT_BOOKING_DETAIL,

    components: {
      cHelpTip
    },

    props: {
        // agencyDet : {
        //     type: Object|Array,
        //     default : null
        // },
        balanceDet : {
            type: Object|Array,
            default : null
        }
    },

    data(){
      return{
        isShowBookingDetail: false,
        agentBookingDetail: {
           ticketedBookings: null,
           pendingBookings: null
        }
      }
    },

    methods: {
    //   async getBookingDetail(b2bid) {
    //       if(BaseConfiguration.isDebug) console.log("getBookingDetail");
          
    //   let returnValue;
    //   try {
    //     let balanceReq = apiGetBalanceDetail.buildRequest(b2bid);
    //     if (balanceReq) {
    //       let balanceRes = await apiGetBalanceDetail.getResponse(balanceReq);
    //       if (VALIDATE_SUCCESS_RES(balanceRes)) {
    //         returnValue = balanceRes.data.data;
    //       } else {
    //         let error = getErrorMessage(balanceRes);
    //         let isJwt = handleJWT(error);
    //         if (!isJwt) {
    //           this.showAlert(getErrorAlertValue(error));
    //         } 
    //       }
    //     } else {
    //       throw "invalid request";
    //     }
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       FILE_NAME.C_AGENT_BOOKING_DETAIL,
    //       "error in  getBookingDetail",
    //       err.toString(),
    //       " getBookingDetail()",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    //   return returnValue;
    // },

    getTicketingCount(bookDet) {
        try {
          if(BaseConfiguration.isDebug) console.log("getTicketingCount");
         // let retValue;
         let ticketed = 0;
         let pending = 0;
         if(bookDet){
         for (let index = 0; index < bookDet.length; index++) {
           const book = bookDet[index];
           ticketed = ticketed + parseInt(book.ticketedbookings);
           pending = pending + parseInt(book.pendingbookings);
         }
         }
         this.agentBookingDetail.ticketedBookings = ticketed;
         this.agentBookingDetail.pendingBookings = pending;
         this.isShowBookingDetail = true;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.C_AGENT_BOOKING_DETAIL,
                  "error in getTicketingCount",
                  err.toString(),
                  "getTicketingCount",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         // return retValue;
        }, 

    },

    async created() {
        try {
          if(BaseConfiguration.isDebug) console.log("created");
          let bookingDetail = [];
          if(this.balanceDet)
         // bookingDetail = await this.getBookingDetail(this.agencyDet.b2bid); 
         bookingDetail = this.balanceDet;
          if(bookingDetail.length>0){
            this.getTicketingCount(bookingDetail);
          }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.C_AGENT_BOOKING_DETAIL,
                  "error in created",
                  err.toString(),
                  "created",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        }, 
}
</script>